import { UpdateApp } from '../../../components/service/accounts/me/apps/UpdateApp';
export const MyAppDetailPageView = () => {
  return <UpdateApp data-sentry-element="UpdateApp" data-sentry-component="MyAppDetailPageView" data-sentry-source-file="[id].tsx" />;
};